export default __webpack_public_path__ + "static/media/building_black.84e1d617.png";